<template>
  <div
    class="list-item"
    :class="{ selected: selected }"
    @click="$emit('click')"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.list-item {
  cursor: pointer;
  border-left: 5px solid transparent;
  line-height: 1.4;
}

.list-item:hover {
  background-color: #f8f8f8;
}

.list-item.selected {
  background-color: #f8f8f8;
  border-left: 5px solid $red-selected;
}
</style>
